module.exports = __webpack_public_path__ + "static/media/1.f4b5204d.png";